import { Component, OnInit } from '@angular/core';
import * as awesom from '@fortawesome/free-solid-svg-icons';
declare var require: any
const FileSaver = require('file-saver');

@Component({
  selector: 'app-cv',
  templateUrl: './cv.component.html',
  styleUrls: ['./cv.component.css']
})
export class CvComponent implements OnInit {
  mapMarker: any ;
  mobile:any;
  email:any;
  badge:any;
  constructor() {
    
   }

  ngOnInit(): void {
    this.mapMarker=awesom.faMapMarker;
    this.email=awesom.faMailBulk;
    this.mobile=awesom.faPhone;
    this.badge=awesom.faGraduationCap;
 
  }
  downloadPdf() {
    const pdfUrl = 'assets/MifdhaMilan.pdf';
    const pdfName = 'Mifdha Milan';
    FileSaver.saveAs(pdfUrl, pdfName);
  }
}

